<div class="flex flex-col items-center justify-center">
    <canvas
        #canvas
        class="h-24 w-52 lg:h-28 lg:w-96 flex"
        [class]="{ hidden: !showWaveform }"
    ></canvas>
    <audio controls #audioTag [class]="{ hidden: !showControls }"></audio>
</div>
